export const SHOW_FOOD_SIDEBAR = "SHOW_FOOD_SIDEBAR"
export const HIDE_FOOD_SIDEBAR = "HIDE_FOOD_SIDEBAR"
export const SHOW_FOOD_SEARCH_BAR = "SHOW_FOOD_SEARCH_BAR"
export const HIDE_FOOD_SEARCH_BAR = "HIDE_FOOD_SEARCH_BAR"
export const TOGGLE_FOOD_SEARCH_BAR = "TOGGLE_FOOD_SEARCH_BAR"
export const TOGGLE_FOOD_SIDEBAR = "TOGGLE_FOOD_SIDEBAR"